// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1663":"7428c3a394589af8","3758":"a0008917daddd038","6169":"d5e267d1fb63a4a1"}[chunkId] + ".css";
};